import type { ThemePalette } from "./types";

export const dracula: ThemePalette = {
	id: "dracula",
	name: "Dracula",
	family: "dracula",
	appearance: "dark",

	background: "#282a36",
	foreground: "#f8f8f2",
	card: "#2d2f3d",
	cardForeground: "#f8f8f2",
	popover: "#2d2f3d",
	popoverForeground: "#f8f8f2",

	primary: "#bd93f9",
	primaryForeground: "#282a36",
	secondary: "#343746",
	secondaryForeground: "#f8f8f2",
	muted: "#343746",
	mutedForeground: "#6272a4",
	accent: "#ff79c6",
	accentForeground: "#282a36",
	destructive: "#ff5555",
	destructiveForeground: "#282a36",

	border: "#44475a",
	input: "#343746",
	ring: "#bd93f9",

	success: "#50fa7b",
	warning: "#ffb86c",
	error: "#ff5555",
	info: "#8be9fd",

	chart1: "#bd93f9",
	chart2: "#ff79c6",
	chart3: "#8be9fd",
	chart4: "#50fa7b",
	chart5: "#f1fa8c",
};
